import { PageHeader } from "../../components/ui";
import ReferenceBoard from "../../components/ReferenceBoard";
import { partnerQueryKeys } from "../../api/queryKeys";
import { fetchPartnerPriceList } from "../../api/endpoints/workspace";

const priceListKey = (params) => [...partnerQueryKeys.all, "price-list", params];

const PriceListPage = () => (
  <div>
    <PageHeader title="Price list" />
    <ReferenceBoard
      queryKey={priceListKey}
      fetcher={fetchPartnerPriceList}
      searchLabel="Search a service or charge"
      emptyTitle="No price list published"
      emptyDescription="The office has not published a price list yet."
      itemNoun="service"
      itemNounPlural="services"
      notesToggleLabel="Requirements and notes"
    />
  </div>
);

export default PriceListPage;
